module.exports = __webpack_public_path__ + "img/icon-logo-white.09bd4985.png";